import type { DocumentListOptions } from '../../types/knowledge';

export const knowledgeQueryKeys = {
  all: ['knowledge'] as const,

  databases: () => [...knowledgeQueryKeys.all, 'databases'] as const,

  database: (databaseId: string) =>
    [...knowledgeQueryKeys.all, 'database', databaseId] as const,

  documents: (databaseId: string, listOptions?: DocumentListOptions) =>
    [
      ...knowledgeQueryKeys.all,
      'documents',
      databaseId,
      listOptions ?? null,
    ] as const,

  documentsRoot: (databaseId: string) =>
    [...knowledgeQueryKeys.all, 'documents', databaseId] as const,

  document: (databaseId: string, documentId: string) =>
    [...knowledgeQueryKeys.all, 'document', databaseId, documentId] as const,

  documentDownload: (databaseId: string, documentId: string) =>
    [
      ...knowledgeQueryKeys.all,
      'documentDownload',
      databaseId,
      documentId,
    ] as const,

  crawls: (databaseId: string) =>
    [...knowledgeQueryKeys.all, 'crawls', databaseId] as const,

  crawlJobStatus: (crawlId: string) =>
    [...knowledgeQueryKeys.all, 'crawlJobStatus', crawlId] as const,

  crawlSchedules: (databaseId: string) =>
    [...knowledgeQueryKeys.all, 'crawlSchedules', databaseId] as const,

  crawlUrlNodes: (databaseId: string, crawlId: string) =>
    [...knowledgeQueryKeys.all, 'crawlUrlNodes', databaseId, crawlId] as const,

  members: (databaseId: string) =>
    [...knowledgeQueryKeys.all, 'members', databaseId] as const,

  groupAssignments: (databaseId: string) =>
    [...knowledgeQueryKeys.all, 'groupAssignments', databaseId] as const,
};
